import { apiFetch } from "../api.js";
import type {
  CollegePlan,
  CollegePlansListResponse,
  CreateCollegePlanInput,
  UpdateCollegePlanInput,
} from "./types.js";

/**
 * College plans — Phase 5 Session 5. Tightened schema; pure-helper
 * projector lives at `web/src/lib/util/college-projector.ts` (driven by
 * the row's growth_rate_pct + cost_inflation_pct + monthly_contribution).
 * Soft-delete via `is_archived`.
 */
export function listCollegePlans(
  includeArchived = false,
): Promise<CollegePlansListResponse> {
  const qs = includeArchived ? "?include_archived=true" : "";
  return apiFetch<CollegePlansListResponse>(`/v1/college-plans${qs}`);
}

export function getCollegePlan(planId: string): Promise<CollegePlan> {
  return apiFetch<CollegePlan>(`/v1/college-plans/${planId}`);
}

export function createCollegePlan(
  input: CreateCollegePlanInput,
): Promise<CollegePlan> {
  return apiFetch<CollegePlan>("/v1/college-plans", {
    method: "POST",
    body: JSON.stringify(input),
  });
}

export function updateCollegePlan(
  planId: string,
  input: UpdateCollegePlanInput,
): Promise<CollegePlan> {
  return apiFetch<CollegePlan>(`/v1/college-plans/${planId}`, {
    method: "PATCH",
    body: JSON.stringify(input),
  });
}

export function deleteCollegePlan(planId: string): Promise<void> {
  return apiFetch<void>(`/v1/college-plans/${planId}`, { method: "DELETE" });
}
